<template>
  <div>
    <el-drawer v-loading="loading" :title="form.id ? (type == '查看' ? '查看客户' : '编辑客户') : '新增客户'" :visible.sync="show" size="95%" :before-close="handleClose" destroy-on-close center :close-on-click-modal="false">
      <el-form ref="form" :disabled="type == '查看' || isRejectTo " :model="form" :rules="rules" label-width="130px">
        <el-card header="基础信息">
          <el-row>
            <el-col :span="6">
              <el-form-item label="申请单号">
                <el-input v-model="form.sn" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户编码">
                <el-input v-model="form.customerApplyNo" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户名称" prop="customerApplyName">
                <el-input v-model="form.customerApplyName" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户类型" prop="customerType">
                <el-select v-model="form.customerType">
                  <el-option v-for="item in customerType" :key="item.code" :value="item.code" :label="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="经营类别" prop="operateCategory">
                <el-select v-model="form.operateCategory" multiple>
                  <el-option v-for="item in businessCategory" :key="item.code" :value="item.code" :label="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系人" prop="contacts">
                <el-input v-model="form.contacts" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系方式" prop="contactsPhone">
                <el-input v-model="form.contactsPhone" type="number" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="地区" prop="areaId">
                <el-select v-model="form.areaId" filterable>
                  <el-option v-for="item in areaOptions" :key="item.id" :value="item.id" :label="item.provinceName" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="省/市/区" prop="provinceId" :required="true">
                <el-cascader v-model="form.region" :props="cascaderProps" :options="areaData" @change="addressChoose" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="详细地址" prop="address">
                <el-input v-model="form.address" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="业务员" prop="salesman">
                <el-input v-model="form.salesman" readonly class="input-with-select">
                  <el-button slot="append" icon="el-icon-search" @click="selectSalesMan" />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据状态">
                <el-select v-model="form.status" :disabled="true" placeholder="自动生成">
                  <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-input v-model="form.note" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人">
                <el-input v-model="form.createUser" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间">
                <el-input v-model="form.createTime" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否终端客户" prop="customerCategory">
                <el-radio-group v-model="form.customerCategory">
                  <el-radio :label="'1'">是</el-radio>
                  <el-radio :label="'2'">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否集团内客户" prop="groupCustomerOrNot">
                <el-radio-group v-model="form.groupCustomerOrNot">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资质" prop="competency">
                <el-select v-model="form.competency" multiple>
                  <el-option v-for="item in competencyCode" :key="item.code" :value="item.code" :label="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card header="销售组织">
          <el-row style="margin: 10px 0">
            <el-button type="primary" icon="el-icon-plus" @click="onAdd('销售')">选择销售组织</el-button>
          </el-row>
          <el-row>
            <el-table ref="elTable" :data="form.customerApplyLineList" border>
              <el-table-column label="销售组织代码" align="left" show-overflow-tooltip width="400">
                <template slot-scope="scope">
                  <el-form-item prop="salesOrganizationNumber">
                    {{ scope.row.salesOrganizationNumber }}
                    <!-- <el-input
                      v-model="scope.row.salesOrganizationNumber"
                      disabled
                    /> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="销售组织名称" align="left" show-overflow-tooltip width="auto">
                <template slot-scope="scope">
                  <el-form-item prop="salesOrganizationName">
                    {{ scope.row.salesOrganizationName }}
                    <!-- <el-input
                      v-model="scope.row.salesOrganizationName"
                      disabled
                    /> -->
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleDeletes(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-card>
        <el-card header="公司代码">
          <!-- <el-row style="margin: 10px 0">
            <el-button type="primary" icon="el-icon-plus" @click="onAdd('财务')">选择公司代码</el-button>
          </el-row> -->
          <el-row>
            <el-table ref="elTable" :data="form.customerFinanceLineList" border>
              <el-table-column label="公司代码" align="left" show-overflow-tooltip width="400">
                <template slot-scope="scope">
                  <el-form-item prop="companyCode">
                    {{ scope.row.companyCode }}
                    <!-- <el-input
                      v-model="scope.row.companyCode"
                      disabled
                    /> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="公司名称" align="left" show-overflow-tooltip width="auto">
                <template slot-scope="scope">
                  <el-form-item prop="companyName">
                    {{ scope.row.companyName }}
                    <!-- <el-input
                      v-model="scope.row.companyName"
                      disabled
                    /> -->
                  </el-form-item>
                </template>
              </el-table-column>

              <!-- <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="handleDelete(scope.$index)"
                  >删除
                  </el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </el-row>
        </el-card>
        <el-card header="客户开票信息">
          <el-row>
            <el-col :span="6">
              <el-form-item label="发票抬头">
                <el-input v-model="form.invoiceTitle" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="纳税人识别号">
                <el-input v-model="form.taxpayerIdentifyNo" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="电话">
                <el-input v-model="form.phone" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开户银行">
                <el-input v-model="form.bankOfDeposit" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="账号名称">
                <el-input v-model="form.accountName" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="银行账号">
                <el-input v-model="form.bankAccount" />
              </el-form-item>
            </el-col>
          </el-row>

        </el-card>
        <el-card header="附件信息">
          <el-row>
            <FileUpload :value.sync="form.customerAccessoryList" :show-delect="form.status<=1 || !form.status" :is-show-tip="false" />
          </el-row>
        </el-card>
        <!-- v-if="form.status != 3" -->
        <el-card header="流程审批">
          <div v-if="form.status <= 1 || form.status==null">
            <el-row>
              <el-col :span="8">
                <el-form-item label="选择流程模板" prop="flowPathTemplateId">
                  <el-select v-model="form.flowPathTemplateId" placeholder="选择模板" @change="getFlowTempInfoList">
                    <el-option v-for="item in flowPathOptions" :key="item.id" :label="item.templateName" :value="item.id" />
                  </el-select>
                </el-form-item>

              </el-col>

            </el-row>
            <!-- <el-row>
              <el-col :span="6">
                <el-button
                  type="primary"
                  style="margin-bottom: 5px;"
                  @click="addNodePerson()"
                >新增审批人</el-button>
              </el-col>
            </el-row> -->

            <el-table v-if="form.flowPathNodePersonModels && form.flowPathNodePersonModels.length>0" ref="elTable" style="width:50%" :data="form.flowPathNodePersonModels" border>
              <el-table-column label="节点名称" align="left" show-overflow-tooltip width="150">
                <template slot-scope="scope">
                  <el-form-item prop="nodePersonName">
                    {{ scope.row.nodePersonName }}
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="审批人" align="left" show-overflow-tooltip width="auto">
                <template slot-scope="scope">
                  <el-form-item :prop="'flowPathNodePersonModels.' + scope.$index + '.nodePerson'" :rules="flowPathNodePersonModels.nodePerson">
                    <el-input v-model="scope.row.nodePerson" readonly placeholder="请点击图标选择">
                      <el-button v-if="scope.row.variable" slot="append" icon="el-icon-search" @click="selectNodePerson(scope.$index)" />
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="deleteNodePerson(scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <Flow ref="flow" :disabled="type == '查看' || form.status > 2" :custom-event="true" :flow-id="form.flowId" @flowLoad="flowLoad" @complete="onComplete" @refresh="flowRefresh" @rejectTo="flowRejectTo" />
        </el-card>
        <el-row style="padding: 10px 20px">
          <el-button :disabled="[3].includes(form.status)" :loading="loading" type="primary" @click="submitForm('form',false)">保存</el-button>
          <el-button v-if="form.id && (form.status == 1 || !form.status)" type="primary" @click="saveAndSubmit()">提交审核</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-row>
      </el-form>
    </el-drawer>
    <el-dialog class="dialog" :title="'选择业务员'" :visible.sync="visible" width="50%" :before-close="close" destroy-on-close center :close-on-click-modal="false">
      <el-table ref="listTable" v-loading="loading" :data="salesManData" border height="300" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column label="业务员" align="left" prop="name" show-overflow-tooltip />
        <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
        <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip />
        <el-table-column label="更新人" align="left" prop="updateUser" show-overflow-tooltip />
        <el-table-column label="更新时间" align="left" prop="updateTime" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.salesman.total" :page.sync="pagination.salesman.current" :limit.sync="pagination.salesman.size" @pagination="getPage" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog class="dialog" :title="'选择销售组织'" :visible.sync="salesDialog" width="50%" :before-close="salesDialogClose" destroy-on-close center :close-on-click-modal="false">
      <el-table ref="listTable" v-loading="loading" :data="salesOrganizationOptions" border height="300" @selection-change="handleSalesSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column label="销售组织代码" align="left" prop="salesOrganizationNumber" show-overflow-tooltip />
        <el-table-column label="销售组织描述" align="left" prop="salesOrganizationName" show-overflow-tooltip />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="salesDialogClose">取消</el-button>
        <el-button type="primary" @click="salesConfirm">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog class="dialog" :title="'选择公司'" :visible.sync="companyDialog" width="50%" :before-close="companyDialogClose" destroy-on-close center :close-on-click-modal="false">
      <el-table ref="listTable" v-loading="loading" :data="companyOptions" border height="300" @selection-change="handleCompanySelectionChange">
        <el-table-column type="selection" width="40" />
        <el-table-column label="公司代码" align="left" prop="companyCode" show-overflow-tooltip />

        <el-table-column label="公司描述" align="left" prop="companyName" show-overflow-tooltip />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="companyDialogClose">取消</el-button>
        <el-button type="primary" @click="companyConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 选择审批人 -->
    <el-dialog class="dialog" :title="'选择审批人'" :visible.sync="showObj.nodePerson" width="30%" :before-close="nodePersonClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.nodePerson.nodePerson" clearable placeholder="请输入审批人名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getNodePersonDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.nodePerson" border height="300" @selection-change="handleNodePersonSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="审批人" align="left" prop="nodePerson" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.nodePerson.total" :page.sync="pagination.nodePerson.current" :limit.sync="pagination.nodePerson.size" @pagination="getNodePersonDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nodePersonClose">取消</el-button>
        <el-button type="primary" @click="nodePersonConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { CodeToText, TextToCode } from 'element-china-area-data'
import FileUpload from '@/components/FileUpload/index'
import Pagination from '@/components/Pagination'
// import { getPage as getSalesOrganization } from '@/api/crm/base/salesOrganization'
import { getPage as getCompany } from '@/api/crm/base/company'
import { getPage as getAreas } from '@/api/crm/base/area'
import Flow from '@/components/Flow'
import format from '@/utils/formatter'
import { getEnumItems } from '@/utils/enum'
import { getByGeneralManager } from '@/api/crm/base/audit'
import { getByPathTemplate, getFlowTempInfo } from '@/api/flow/processConfiguration'

import {
  get,
  saveOrUpdate,
  areaList,
  submit,
  page,
  getSalesOrganization
} from '@/api/crm/customer/customerApplication'
import { mergeObjectArrayWithoutDuplicates } from '@/utils/index'
export default {
  name: 'CustomerApplicationEdit',
  components: {
    FileUpload,
    Flow,
    Pagination
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    },
    editId: Number
  },

  data() {
    return {
      companySelection: [],
      salesSelection: [],
      salesOrganizationOptions: [],
      companyDialog: false,
      salesDialog: false,
      visible: false,
      statusOptions: [
        {
          label: '制单',
          value: 1
        },
        {
          label: '审核中',
          value: 2
        },
        {
          label: '审核完成',
          value: 3
        },
        {
          label: '驳回',
          value: 4
        }
      ],
      multipleSelection: [],
      salesManData: [],
      companyOptions: [],
      companyCodeOptions: [],
      salesOrganizationCodeOptions: [],
      flowPathOptions: [],
      format: format,
      businessCategory: getEnumItems('Crm_Business_Category'),
      competencyCode: getEnumItems('competencyCode'),
      customerType: getEnumItems('Crm_Customer_Type'),
      areaData: [],
      type: '',
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL,
      loading: false,
      form: {
        customerApplyLineList: [],
        customerFinanceLineList: [],
        customerAccessoryList: [],
        salesmanId: null,
        salesman: null,
        areaId: null,
        provinceId: null,
        flowPathNodePersonModels: [],
        flowPathTemplateId: null,
        roleId: null,
        operateCategory: [],
        competency: []
      },
      flowPathNodePersonModels: {
        nodePerson: [
          { required: true, message: '审批人不能为空', trigger: 'change' }
        ]
      },
      rules: {
        customerApplyName: [
          { required: true, message: '客户名称不能为空', trigger: 'blur' }
        ],
        customerType: [
          { required: true, message: '客户类型不能为空', trigger: 'change' }
        ],
        operateCategory: [
          { required: true, message: '经营类别不能为空', trigger: 'change' }
        ],
        customerCategory: [
          {
            required: true,
            message: '请选择是否终端客户',
            trigger: 'change'
          }
        ],
        groupCustomerOrNot: [
          {
            required: true,
            message: '请选择是否集团内客户',
            trigger: 'change'
          }
        ],
        contacts: [
          { required: true, message: '联系人不能为空', trigger: 'blur' }
        ],
        contactsPhone: [
          { required: true, message: '联系方式不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '详细地址不能为空', trigger: 'blur' }
        ],
        salesman: [
          {
            required: true,
            message: '业务员不能为空',
            trigger: ['change']
          }
        ],
        areaId: [
          {
            required: true,
            message: '地区不能为空',
            trigger: 'change'
          }
        ],
        provinceId: [
          {
            required: true,
            message: '省/市/区不能为空',
            trigger: 'blur'
          }
        ]
      },
      clientClassOptions: [],
      // 分页
      // pagination: {
      //   total: 0,
      //   size: 20,
      //   current: 1
      // },
      // condition: {},
      areaOptions: [],
      showObj: {
        nodePerson: false
      },
      loadingObj: {
        nodePerson: false
      },
      // 分页
      pagination: {
        salesman: {
          total: 0,
          size: 20,
          current: 1
        },
        nodePerson: {
          total: 0,
          size: 20,
          current: 1
        }
      },
      dialog: {
        nodePerson: []
      },
      condition: {
        salesman: {},
        nodePerson: {}
      },
      selection: {
        nodePerson: []
      },
      nodePersonIndex: null,
      isRejectTo: false,
      roleId: null,
      cascaderProps: {
        value: 'areaCode',
        label: 'areaName',
        lazy: true,
        lazyLoad: this.layzesss
      }
    }
  },
  watch: {
    show(show) {
      if (!show) {
        return
      }

      this.getAreaData()
      this.init()
      this.flowPathNodePersonModels.nodePerson[0].required = false
      if (this.editId == null) {
        this.form = this.$options.data.call(this).form
        return
      }
      this.getData()
    }
  },
  methods: {
    companyConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.customerFinanceLineList))
      if (arr !== null && arr.length > 0) {
        this.form.customerFinanceLineList = mergeObjectArrayWithoutDuplicates(arr, this.companySelection, 'companyInfoId')
      } else {
        this.form.customerFinanceLineList = this.companySelection
      }
      console.log(this.form.customerFinanceLineList)
      this.companyDialog = false
    },
    salesConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.customerApplyLineList))
      for (var i = 0; i < this.salesSelection.length; i++) {
        this.salesSelection[i].salesOrganizationId = this.salesSelection[i].id
      }
      if (arr !== null && arr.length > 0) {
        this.form.customerApplyLineList = mergeObjectArrayWithoutDuplicates(arr, this.salesSelection, 'salesOrganizationNumber')
      } else {
        this.form.customerApplyLineList = this.salesSelection
      }
      this.filtrationCompany(this.form.customerApplyLineList)
      this.salesDialog = false
    },
    // 根据销售组织过滤出公司代码
    filtrationCompany(arr) {
      const list = []
      for (const item of arr) {
        if (list.findIndex(v => v.companyCode === item.customerFinanceLineList[0].companyCode) === -1) {
          list.push(item.customerFinanceLineList[0])
        }
      }
      this.form.customerFinanceLineList = list
      console.log(this.form.customerFinanceLineList, 11112)
    },
    companyDialogClose() {
      this.companyDialog = false
    },
    salesDialogClose() {
      this.salesDialog = false
    },
    handleCompanySelectionChange(val) {
      for (const item of val) {
        item.companyInfoId = item.id
        item.companyName = item.companyName
        item.companyCode = item.companyCode
      }
      this.companySelection = val
    },
    handleSalesSelectionChange(val) {
      console.log(val)
      this.salesSelection = val
    },
    confirm() {
      // debugger
      if (this.multipleSelection.length > 1) {
        this.$message.warning('只能选择一位业务员！')
      } else {
        this.visible = false
        this.form.salesmanId = this.multipleSelection[0]?.id
        this.form.salesman = this.multipleSelection[0]?.name
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    selectSalesMan() {
      this.visible = true
      this.getPage()
    },
    getPage() {
      this.loading = true
      page(this.condition.salesman, this.pagination.salesman)
        .then((response) => {
          const { current, total, size, records } = response.data
          this.salesManData = records
          this.pagination.total = total
          this.pagination.current = current
          this.pagination.size = size
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 省市区三级联动 */
    addressChoose(value) {
      this.form.provinceId = value[0]
      this.form.cityId = value[1]
      this.form.countyId = value[2]
    },
    async layzesss(node, resolve) {
      console.log(node, node.level)
      // console.log(this.areaData)
      // if (node.level === 1) {
      //   return
      // }
      const levelArr = ['', 'province', 'city', 'district']
      if (node.level === 3) {
        return resolve([])
      }
      const { data } = await areaList({ level: levelArr[node.level + 1], areaCode: node.value || '' })
      if (data.length > 0) {
        for (const item of data) {
          item.leaf = node.level >= 2
        }
      }

      return resolve(data)
    },
    async getAreaData() {
      const { data } = await areaList({ level: 'province', areaCode: '' })
      // this.areaData = arrayToTree([
      //   ...data[0].provinceList,
      //   ...data[0].cityList,
      //   ...data[0].districtList
      // ])
      // if (this.areaData.length <= 0) {
      //   this.areaData = data
      // }
    },
    init() {
      getSalesOrganization({}, { current: 1, size: 10 }).then((response) => {
        const { records } = response.data
        this.salesOrganizationOptions = records
      })
      getCompany({}, { current: 1, size: 10 }).then((response) => {
        const { records } = response.data
        this.companyOptions = records
      })
      getAreas({}, { current: 1, size: 100 }).then((res) => {
        const { records } = res.data
        this.areaOptions = records
      })
      getByPathTemplate({ templateType: '客户' }, { current: 1, size: 100 }).then((res) => {
        const { records } = res.data
        this.flowPathOptions = records
        console.log(this.flowPathOptions)
      })
    },
    async getFlowTempInfoList(e) {
      this.loading = true
      this.form.flowPathNodePersonModels = []
      const i = this.flowPathOptions.findIndex(v => v.id === e)
      this.form.roleId = this.flowPathOptions[i].roleId
      // , this.flowPathOptions[i].roleId

      try {
        const res = await getFlowTempInfo(this.flowPathOptions[i].templateName)
        const nodeList = res.data.nodeList
        nodeList.shift()
        for (const item of nodeList) {
          let nodeVariate = ''
          const arr = []
          for (const v of item.userList) {
            if (v.variable) {
              v.username = v.username.substring(2, 13)
            }
            arr.push(v.username)
          }
          nodeVariate = arr.join()

          // 指定审核人赋值
          let nodePerson = null
          if (!item.userList[0].variable) {
            nodePerson = nodeVariate
          } else {
            nodePerson = null
          }
          this.form.flowPathNodePersonModels.push({
            nodePersonName: item.name,
            nodeVariate,
            nodePerson,
            nodePersonId: null,
            variable: item.userList[0].variable
          })
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    // 选择审批人

    // addNodePerson() {
    //   if (this.form.flowPathNodePersonModels === null) {
    //     this.form.flowPathNodePersonModels = []
    //   }
    //   this.form.flowPathNodePersonModels.push({})
    // },
    // deleteNodePerson(index) {
    //   this.form.flowPathNodePersonModels.splice(index, 1)
    // },
    selectNodePerson(index) {
      this.nodePersonIndex = index
      this.showObj.nodePerson = true
      this.getNodePersonDialog()
    },
    async getNodePersonDialog() {
      this.loadingObj.nodePerson = true
      const reponse = await getByGeneralManager(this.condition.nodePerson.nodePerson, this.form.roleId, this.pagination.nodePerson)
      const { current, total, size, records } = reponse.data
      this.dialog.nodePerson = records
      this.pagination.nodePerson.total = total
      this.pagination.nodePerson.current = current
      this.pagination.nodePerson.size = size
      this.loadingObj.nodePerson = false
    },

    handleNodePersonSelectionChange(val) {
      this.selection.nodePerson = val
    },
    nodePersonConfirm() {
      if (this.selection.nodePerson.length > 1) {
        this.$message.warning('只能选择一位审批人！')
      } else {
        this.showObj.nodePerson = false
        console.log(this.selection.nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePerson', this.selection.nodePerson[0].nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePersonId', this.selection.nodePerson[0].nodePersonId)
      }
    },
    nodePersonClose() {
      this.showObj.nodePerson = false
    },
    onAdd(type) {
      this.salesDialog = true
      // if (type == '销售') {
      //   this.salesDialog = true
      // } else if (type == '财务') {
      //   this.companyDialog = true
      // }
    },
    handleDelete(index) {
      this.form.customerFinanceLineList.splice(index, 1)
    },
    handleDeletes(index) {
      this.form.customerApplyLineList.splice(index, 1)
      this.filtrationCompany(this.form.customerApplyLineList)
    },
    async getData() {
      if (!this.editId) return
      this.loading = true
      try {
        const response = await get(this.editId)
        const { data } = response
        this.form = data
        this.form.flowPathTemplateId = this.form.flowPathTemplateId === 0 ? null : this.form.flowPathTemplateId
        this.handleData()
        this.flowRejectTo(null, null)
        this.loading = false
        this.$nextTick(() => {
          // this.$refs.elTable.doLayout()
        })
      } catch (error) {
        this.loading = false
      }
    },
    handleData() {
      this.form.region = []
      this.form.region[0] = this.form.provinceId.toString()
      this.form.region[1] = this.form.cityId.toString()
      this.form.region[2] = this.form.countyId.toString()
      this.form.customerType = this.form.customerType.toString()

      this.form.operateCategory = this.form.operateCategory.split(',')
      this.form.competency = this.form.competency ? this.form.competency.split(',') : []
      // this.form.companyInfoFactoryLineList = this.form.companyInfoFactoryLineList || []
      this.form.warehouseList = this.form.warehouseList || []
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$router.push({ query: {} })
      this.$emit('close')
    },
    async submitForm(formName, isClose = true, cb) {
      // ---- 需要手工填写此代码 -----
      this.$refs[formName].validate(async (valid, obj) => {
        if (valid) {
          // ---- 需要手工填写此代码 -----
          try {
            this.loading = true
            const formData = JSON.parse(JSON.stringify(this.form))
            formData.operateCategory = this.form.operateCategory.join()
            formData.competency = this.form.competency.join()
            const { message, data } = await saveOrUpdate(formData)
            this.$message({
              type: 'success',
              message: message
            })
            // this.form.id = this.form.id || data
            this.editId = this.form.id || data
            console.log(this.editId)
            await this.getData()
            this.loading = false
            if (cb) {
              await cb()
            }
            if (isClose) {
              this.handleClose()
            }
          } catch (error) {
            this.loading = false
          }
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    flowLoad(e) {
      this.flowOptions = e
      this.$refs.flow.validatorForm.push(this.$refs.isProceeds)
    },
    flowRefresh() {
      this.getData()
      this.handleClose()
    },
    flowRejectTo(isAssignee, nodeName) {
      if (isAssignee && nodeName === '开始') {
        this.isRejectTo = false
      } else {
        if (this.form.status > 1) {
          this.isRejectTo = true
        } else {
          this.isRejectTo = false
        }
      }
    },
    async submit() {
      try {
        this.loading = true
        const response = await submit(this.form.id)
        this.form.flowId = response.data
        // this.handleClose()
        this.getData()
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    // 流程提交
    async onComplete() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        // await this.getData();
        // 在执行提交
        await this.$refs.flow.onComplete()
        this.handleClose()
      })
    },
    // 保存并提交
    async saveAndSubmit() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        await this.submit()
      })
    },
    close() {
      this.visible = false
    }

  }
}
</script>
<style scoped>
.link {
  color: #606266;
  font-weight: lighter;
}
.link:hover {
  color: rgb(64, 158, 255);
  font-weight: lighter;
}
.upload {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
}
.upload >>> .el-upload-list__item:first-child {
  margin-top: 0;
}
.uploads {
  clear: both;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.el-upload {
  flex: 1;
}

.el-upload__tip {
  margin-top: 0;
  margin-left: 10px;
  flex: 1;
}
.el-col {
  min-height: 50px;
}
.dialog >>> .el-dialog__body {
  overflow: hidden !important;
}
.footer-box {
  margin-top: 10px;
}
</style>
